module.exports = __webpack_public_path__ + "img/balance.2c4a65a2.png";